import Vue from 'vue'
import Vuex from 'vuex'	
import mygoods from './modules/mygoods.js'
import bindgood from './modules/bindgood.js'
import order from './modules/order.js'
import login from './modules/login.js'
import shopaccess from './modules/shopaccess.js'
import picklist from './modules/picklist.js'
import userStoreItems from './modules/userStoreItems.js'
import sellerpurchase from './modules/sellerpurchase.js'
import lazadaorders from './modules/lazadaorders.js'
import lazadaprocessed from './modules/lazadaprocessed.js'
import recharge from './modules/recharge.js'
import print from './modules/print.js'
import processed from './modules/processed.js'
import deduction from './modules/deduction.js'
import customer from './modules/customer.js'
import remind from './modules/remind.js'
import chat from './modules/chat.js'
import common from './modules/common'



Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
	order,
	mygoods,
	bindgood,
	login,
	shopaccess,
	picklist,
	userStoreItems,
	sellerpurchase,
	lazadaorders,
	lazadaprocessed,
	recharge,
	print,
	processed,
	deduction,
	customer,
	remind,
	chat,
	common,
  },
})